module.exports = __webpack_public_path__ + "media/educators/nacac-92801473.png";